module.exports = __webpack_public_path__ + "img/logo_ausgeschrieben.47c765c3.png";